var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCohortSort = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13137 0.0322266C4.38494 0.0322266 4.5905 0.237789 4.5905 0.491358V11.5105C4.5905 11.7641 4.38494 11.9697 4.13137 11.9697C3.8778 11.9697 3.67224 11.7641 3.67224 11.5105V0.491358C3.67224 0.237789 3.8778 0.0322266 4.13137 0.0322266Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45682 0.133991C4.27753 -0.0453148 3.98682 -0.0453148 3.80752 0.133991L0.134475 3.80704C-0.044825 3.98635 -0.044825 4.27705 0.134475 4.45635C0.313775 4.63566 0.604485 4.63565 0.783785 4.45635L4.45682 0.783301C4.63612 0.603995 4.63612 0.313291 4.45682 0.133991Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19222 0.0605469C7.44579 0.0605469 7.65136 0.266103 7.65136 0.519678V11.5388C7.65136 11.7924 7.44579 11.9979 7.19222 11.9979C6.93866 11.9979 6.73309 11.7924 6.73309 11.5388V0.519678C6.73309 0.266103 6.93866 0.0605469 7.19222 0.0605469Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1899 7.54366C11.3692 7.72297 11.3692 8.01363 11.1899 8.19293L7.51685 11.866C7.33754 12.0453 7.04688 12.0453 6.86757 11.866C6.68827 11.6867 6.68827 11.396 6.86757 11.2167L10.5406 7.54366C10.7199 7.36435 11.0106 7.36435 11.1899 7.54366Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCohortSort);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cohort-sort.95081df14167a901248b7b75e4fc9463.svg";